module.exports = __webpack_public_path__ + "static/media/ticket.f95247a6.svg";